<template>
    <v-card tile :flat="flat" :style="cardStyle" :class="cardClass">
        <!--Toolbar-->
        <v-toolbar
            card
            :dark="isToolbarDark"
            :color="toolbarColor"
            :class="{'elevation-1': true, 'click': toolbarClickable}"
            @click.native.stop="toolbarClickable ? handleClose() : null"
        >
            <v-toolbar-title v-if="title">{{ title }}</v-toolbar-title>
            <v-spacer v-if="title"></v-spacer>
            <w-btn v-if="!hideCloseButton" icon :icon-name="closeButtonIcon" @click.native.stop="handleClose"></w-btn>
        </v-toolbar>

        <!--Form content-->
        <div v-show="!hideContent">
            <v-card-text :class="{'pt-0': dense, 'pb-0': true}">
                <!--Logo image if src is supplied-->
                <img v-if="hasLogoSrc" :src="logoSrc" :style="logoStyle" alt="logo"/>

                <slot name="alerts"></slot>
                <!--WFormErrorAlerts-->
                <w-form-error-alerts
                    v-if="hasFormErrorAlerts"
                    v-bind="wFormErrorAlertsProps"
                ></w-form-error-alerts>
            </v-card-text>

            <!--WForm-->
            <w-form v-bind="wFormProps" v-on="wFormEvents" ref="form">
                <v-card-text :class="{'pb-0': dense, 'pt-0': true}">
                    <v-layout row wrap>
                        <!-- @slot top -->
                        <slot name="top"></slot>
                        <v-flex xs12 pt-0 px-0 v-if="description">
                            <w-description v-if="description" v-bind="wDescriptionProps"></w-description>
                        </v-flex>
                        <!-- @slot default-->
                        <slot></slot>
                    </v-layout>
                </v-card-text>
                <v-container grid-list-lg fluid slot="actions">
                    <v-layout wrap>
                        <v-flex xs12 :class="{'pr-0': dense}">
                            <!--Form actions-->
                            <w-card-form-actions
                                v-if="!hideActions"
                                v-bind="wCardFormActionsProps"
                                v-on="wCardFormActionsEvents"
                            ></w-card-form-actions>
                            <!--Custom form actions-->
                            <v-card-actions v-if="hideActions">
                                <!-- @slot actions-->
                                <slot name="actions"></slot>
                            </v-card-actions>
                            <template v-else>
                                <!-- @slot actions-->
                                <slot name="actions"></slot>
                            </template>
                        </v-flex>
                    </v-layout>
                </v-container>
            </w-form>
        </div>
    </v-card>
</template>

<script>
    import {isEmpty} from 'underscore'
    import WBtn from '../WBtn'
    import WCardFormActions from '../WCardFormActions'
    import WDescription from '../WDescription'
    import WForm from '../WForm'
    import WFormErrorAlerts from '../WFormErrorAlerts'

    import WCardFormMixin from '../../mixins/forms/w-card-form-mixin'

    /**
     * A WCard component which uses WForm and WForm actions to provide a customizable form.
     */
    export default {
        name: 'WCardForm',
        mixins: [WCardFormMixin],
        components: {
            WBtn,
            WCardFormActions,
            WDescription,
            WForm,
            WFormErrorAlerts
        },
        computed: {
            cardClass () {
                const vm = this

                return {
                    'elevation-1': vm.flat,
                    'elevation-12': !vm.flat,
                    [`text-xs-${vm.align}`]: true
                }
            },
            cardStyle () {
                const vm = this
                let widthStyle = {width: null, 'max-width': null}
                const width = vm.width
                const maxWidth = vm.maxWidth

                if (typeof width !== 'boolean') {
                    widthStyle.width = typeof width === 'number' ? `${width}px` : width
                }

                if (typeof maxWidth !== 'boolean') {
                    widthStyle['max-width'] = typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth
                }

                return {...widthStyle, ...vm.marginStyle}
            },
            hasLogoSrc () {
                return !isEmpty(this.logoSrc)
            }
        }
    }
</script>
/